"use client"

import React, { type JSX } from "react"

import PageGrid from "../../PageGrid"

import ClimateActionCarousel from "./ClimateActionCarousel"

type EnablingClimateActionProps = {
  heading: string
  copy: string
  slides: {
    id: number
    heading: string
    copy: JSX.Element
    image: JSX.Element
    logoActive: JSX.Element
    logoInactive: JSX.Element
  }[]
}

const EnablingClimateAction: React.FC<EnablingClimateActionProps> = (
  props: EnablingClimateActionProps,
) => {
  const { heading, copy, slides } = props

  return (
    <>
      <section className="xl:pb-28 md:pb-20 pb-15 bg-gray-90">
        <PageGrid>
          <div className="p-4 lg:col-span-8 md:col-span-3 col-span-full">
            <h2 className="text-gray-2.5 heading1 md:headline5 xl:headline4 mb-10 md:mb-12 xl:mb-20">
              {heading}
            </h2>
            <p className="text-gray-2.5 body3 xl:body1">{copy}</p>
          </div>
        </PageGrid>
      </section>
      <section className="xl:pb-24 bg-gray-90">
        <PageGrid isGrid={false}>
          <div className="w-full py-0 md:py-4">
            <ClimateActionCarousel slides={slides} />
          </div>
        </PageGrid>
      </section>
    </>
  )
}

export default EnablingClimateAction
